export default [
    {
        path: '/product/new/type/:type',
        name: 'product-new',
        component: () => import('@/views/product/NewProduct.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/product/new/type',
        name: 'product-new-wizard',
        component: () => import('@/views/product/ProductTypeWizard.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/product/overview',
        name: 'product-overview',
        component: () => import('@/views/product/ProductOverview.vue'),
    },
    {
        path: '/product/:id/card',
        name: 'product-card',
        component: () => import('@/views/product/ProductCard.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/product/:id/scip-notification',
        name: 'product-scip-notification',
        component: () => import('@/views/product/scip-notification/SCIPNotificationPreview.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: "/product/:id/send-request",
        name: 'product-send-request',
        component: () => import('@/views/product/SendRequest.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/submission/overview',
        name: 'submission-overview',
        component: () => import('@/views/product/scip-notification/SubmissionOverview.vue'),
    },
    {
        path: '/submission/:id/card',
        name: 'submission-card',
        component: () => import('@/views/product/scip-notification/SubmissionCard.vue'),
        props: (route) => {
            return route.params;
        }
    }
];
